<template>
  <v-app class="app">
    <div class="flex">
      <card-details-profiler :authorData="authorData" />
      <v-tabs v-model="activeTab" class="tabs" background-color="transparent" dark>
        <v-tab>Suas Obras</v-tab>
        <v-tab>Favoritos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab" dark>
        <v-tab-item>
          <div class="fixed-works-section">
            <div class="my-list">
              <div v-if="minhasObras.length === 0" class="no-works-message">
                O usuário não tem obra publicada.
              </div>
              <div v-for="(item, index) in visibleWorks" :key="index" class="list">
                <ProjectCard :cardData="item" />
              </div>
              <div v-if="minhasObras.length > 6" class="view-all-button">
                <button @click="toggleShowAll" class="unstyled-button">
                  {{ showAll ? "Ver Menos" : "Ver Todos" }}
                </button>
              </div>
            </div>
          </div>
        </v-tab-item>


        <v-tab-item>
          <div class="bg-color">
            <div>
              <div class="flex-favorites">
                <div v-if="minhaLista.length === 0" class="no-works-message">
                  O usuário ainda não tem nenhuma obra favorita.
                </div>
                <div v-for="(item, index) in minhaLista" :key="index" class="flex-favorites">
                  <ProjectCard :cardData="item" />
                </div>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

  </v-app>
</template>

<script>
import CardDetailsProfiler from '@/components/CardDetailsProfiler.vue';
import { getAuthorProjects } from '../server/workService';
import { getFavoriteProjects } from '@/server/userServe';
import ProjectCard from '@/components/cards/ProjectCard.vue'

export default {
  name: "ProfilerUserView",
  components: {
    CardDetailsProfiler,
    ProjectCard
  },
  data() {
    return {
      showAll: false,
      activeTab: 0,
      minhasObras: [],
      minhaLista: [],
      authorData: [],
    };
  },
  async created() {
    await this.findProjectsProfile();
    await this.fetchFavoriteProjects();
  },
  computed: {
    visibleWorks() {
      // Exibe os primeiros 10 itens ou todos, dependendo do estado
      return this.showAll ? this.minhasObras : this.minhasObras.slice(0, 6);
    },
  },
  methods: {
    toggleShowAll() {
      // Alterna entre exibir todos os itens ou apenas 10
      this.showAll = !this.showAll;
    },
    async findProjectsProfile() {
      try {
        const responseData = await getAuthorProjects();
        this.minhasObras = responseData.projects || [];
        this.minhaLista = responseData.follow_projects || [];
        this.authorData = {
          ...responseData.author,
          projects: this.minhasObras,
          follow_projects: this.minhaLista,
        };
      } catch (error) {
        console.error("Erro ao buscar projetos do autor:", error);
      }
    },

    // Para buscar os projetos favoritos
    async fetchFavoriteProjects() {
      try {
         await getFavoriteProjects();
      } catch (error) {
       throw new Error("Ocorreu um erro ao buscar os projetos favoritos");

      }
    }

  },
};
</script>


<style scoped>
.v-tabs {
  /* flex: 1 1 auto; */
  width: 100%;
}

.bg-color {
  background-color: #1D1D1D !important;
}

.view-all-button {
  width: 100%;
  display: flex;
  justify-content: star;
  margin-top: 1rem;
}

.unstyled-button {
  background: none;
  border: none;
  color: #a21bf0;
  /* Azul padrão para links */
  cursor: pointer;
  text-decoration: underline;
  font-size: 1rem;
  padding: 0;
}

.unstyled-button:hover {
  text-decoration: none;
  /* Remove sublinhado ao passar o mouse */
}

.no-works-message {
  text-align: center;
  color: #999;
  margin-top: 20px;
  min-width: 500px;
  width: 100%;
}

.flex-favorites {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}


.app {
  background-color: #1D1D1D !important;
}

.flex {
  display: flex;
  flex-direction: column;
  background-color: #1D1D1D !important;
  gap: 20px;
}

.fixed-works-section {
  flex: 0 0 350px;
  max-width: 350px;
}

.my-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.my-list .list {
  display: block;
  width: 100%;
}

.unstyled-button {
  color: #a21bf0;
  font-weight: bold;
  border-radius: 5px;
  padding: 8px 12px;
  transition: background 0.3s ease;
}

.unstyled-button:hover {
  background: rgba(162, 27, 240, 0.1);
}



@media (max-width: 530px) {
  .flex {
    flex-direction: column;
  }

  .flex-favorites {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .list {
    padding: 5px 5px !important;
  }

  .my-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding-left: 0px !important;
    padding-bottom: 90px !important;
  }

  .fixed-works-section {
    max-width: 100%;
    flex: 1;
  }
}



@media (max-width: 1440px) {
  .my-list {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(4, 1fr);
  }

  .flex-favorites {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1024px) {
  .main-content[data-v-796b66be] {
    background-color: #1d1d1d !important;
    padding: 19px 4px 0px 91px !important;
  }

  .my-list {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(3, 1fr);
  }

  .flex-favorites {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .main-content[data-v-796b66be] {
    background-color: #1d1d1d !important;
    padding: 19px 4px 0px 91px !important;
  }

  .my-list {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(5, 1fr);
  }

  .flex-favorites {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 890px) {
  .my-list {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(3, 1fr);
  }

  .flex-favorites {
    display: grid;
    padding-left: 12px;
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>